import { render, staticRenderFns } from "./TabelaAnexos.vue?vue&type=template&id=6925d17a"
import script from "./TabelaAnexos.vue?vue&type=script&lang=js"
export * from "./TabelaAnexos.vue?vue&type=script&lang=js"
import style0 from "./TabelaAnexos.vue?vue&type=style&index=0&id=6925d17a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports